import React from "react";
import { AddHolidayCalendarContainer } from "../../../containers";

const AddHolidayCalendar = (props) => {
  return <AddHolidayCalendarContainer {...props} />;
};

export default AddHolidayCalendar;
